<template>
    <div>
        <span v-if="user" class="ph-no-capture">
            <span
                v-if="!mini"
                class="mr-2 text-typography1 text-capitalize text-body-medium"
            >
                {{ user.givenName }} {{ user.surname }}
            </span>

            <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ props }">
                    <v-avatar size="40" v-bind="props">
                        <img v-if="userPhoto" :src="userPhoto" />
                        <v-icon v-else>mdi-account-circle</v-icon>
                    </v-avatar>
                </template>
                <v-list>
                    <v-list-item>
                        <template v-slot:prepend>
                            <v-avatar size="55">
                                <img v-if="userPhoto" :src="userPhoto" />
                                <v-icon v-else>mdi-account-circle</v-icon>
                            </v-avatar>
                        </template>
                        <v-list-item-title>
                            {{ user.displayName }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="d-flex flex-column">
                            <span class="text-caption">{{ user.mail }}</span>
                            <span class="text-caption">{{ user.userId }}</span>
                        </v-list-item-subtitle>
                    </v-list-item>
                    <v-divider class="mt-3"></v-divider>
                    <v-list-item @click="logout">
                        <template v-slot:prepend>
                            <v-icon color="black">mdi-logout</v-icon>
                        </template>
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </span>

        <v-btn
            v-else
            class="mr-2 text-typography2 text-capitalize"
            variant="text"
            @click="login"
        >
            Login
        </v-btn>
    </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useDisplay } from 'vuetify'

const store = useStore()
const router = useRouter()
const route = useRoute()
const { lgAndDown } = useDisplay()

const user = computed(() => store.state.user)
const userPhoto = computed(() => store.state.userPhoto)
const showProgressLogin = computed(() => store.state.showProgressLogin)
const mini = computed(() => lgAndDown.value)

function logout() {
    store.dispatch('logout')
}
function login() {
    store.dispatch('login')
}

login()

watch(showProgressLogin, (progress) => {
    if (route.name !== 'home') {
        if (!progress && !user.value) {
            router.push({ path: '/' })
        }
    }
})
</script>
